
const kindergartenClassId = [
  'b9fdf1ddf7ac4289a9044391b141e708',
  '5c8cca44e6574cf5af538694c3a5b785',
  '50e26013aa694023b163420a022ee770'
]
const primarySchoolClassId = [
  '5391e3bff43547b4a756e480cd70d275',
  '5c9687f0b1a04855b4d8d251b821579c',
  'c6f67dedb21f4e76af13d12aa9d4f840',
  '1f06147afa474766911d5de2d68325ee',
  '7a77f339152b4076a0d630bf8877eb8e',
  'ab187ecec9b541b08a8ecb9692d19450',
  '63b690ae1c284ec39f55ebbc22d33509',
  '3d35de706ea840b68c28e84ff5168b14',
  '0580c8000c6f4dda9b94220b4a45c3a8',
]

const middleSchoolClassId = [
  '32995ffacccf4055a5246249ff9b0f2d',
  '9ef072f536724978b2becfb9b06d91ea',
  '8cb3f6b8175e48089a93cbe938373316',
]


const kindergartenClass = [
  {
    name: '小班',
    key: kindergartenClassId[0]
  }, {
    name: '中班',
    key: kindergartenClassId[1]
  }, {
    name: '大班',
    key: kindergartenClassId[2]
  }
]
const primarySchoolClass = [
  {
    name: '一年级',
    key: primarySchoolClassId[0]
  },
  {
    name: '二年级',
    key: primarySchoolClassId[1]
  },
  {
    name: '三年级',
    key: primarySchoolClassId[2]
  },
  {
    name: '四年级',
    key: primarySchoolClassId[3]
  },
  {
    name: '五年级',
    key: primarySchoolClassId[4]
  },
  {
    name: '六年级',
    key: primarySchoolClassId[5]
  },
  {
    name: '七年级',
    key: primarySchoolClassId[6]
  },
  {
    name: '八年级',
    key: primarySchoolClassId[7]
  },
  {
    name: '九年级',
    key: primarySchoolClassId[8]
  },
]

const middleSchoolClass = [
  {
    name: '高一',
    key: middleSchoolClassId[0]
  }, {
    name: '高二',
    key: middleSchoolClassId[1]
  }, {
    name: '高三',
    key: middleSchoolClassId[2]
  }
]


const allIdList = kindergartenClassId.concat(primarySchoolClassId).concat(middleSchoolClassId)

export { kindergartenClass, primarySchoolClass, middleSchoolClass, allIdList }
